// extracted by mini-css-extract-plugin
module.exports = {"progressBar":"progressBar__1RupT","completed":"completed__3byEC"};